module.exports = __webpack_public_path__ + "img/icon-touched-18.ee1a0fbb.svg";